<template>
  <ChannelHeaderActionsProvider
    v-if="accountType === 'sitter'"
    :correspondingUserAccountId="correspondingUserAccountId"
    :currentChannelUrl="currentChannelUrl"
  />
  <ChannelHeaderActionsSeeker
    v-else
    :correspondingUserAccountId="correspondingUserAccountId"
    :correspondingUserId="correspondingUserId"
    :currentChannelUrl="currentChannelUrl"
  />
</template>

<script lang="ts">
import ChannelHeaderActionsProvider from '@/apps/messages/components/channelHeader/ChannelHeaderActionsProvider.vue';
import ChannelHeaderActionsSeeker from '@/apps/messages/components/channelHeader/ChannelHeaderActionsSeeker.vue';

export default {
  name: 'ChannelHeaderActions',
  components: {
    ChannelHeaderActionsProvider,
    ChannelHeaderActionsSeeker,
  },
  props: {
    correspondingUserAccountId: {
      type: String,
      default: '',
    },
    correspondingUserId: {
      type: String,
      default: '',
    },
    accountType: {
      type: String,
      required: true,
    },
    currentChannelUrl: {
      type: String,
      default: '',
    },
  },
};
</script>
